/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { AbsencesEffects } from '@absences/store/absences.effects';
import { NgModule } from '@angular/core';
import { CustomersEffects } from '@app/customers/store/customers.effects';
import { UsersEffects } from '@app/user/store/users.effects';
import { AppointmentEffects } from '@appointments/store/appointment.effects';
import { AuthEffects } from '@auth/store/auth.effects';
import { ConstructionSitesEffects } from '@construction-sites/store/construction-sites.effects';
import { DepartmentsEffects } from '@departments/store/departments.effects';
import { DriversEffects } from '@drivers/store/drivers.effects';
import { environment } from '@env/environment';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { RemindersEffects } from '@reminders/store/reminders.effects';
import { SharedModule } from '@shared/shared.module';
import { TourEffects } from '@tours/store/tours.effects';
import { VehiclesEffects } from '@vehicles/store/vehicles.effects';
import { HeaderComponent } from './header/header.component';
import { NavigationComponent } from './header/navigation/navigation.component';
import { reducers } from './store';

@NgModule({
  declarations: [
    HeaderComponent,
    NavigationComponent
  ],
  imports: [
    SharedModule,
    StoreModule.forRoot(reducers),
    EffectsModule.forRoot([
      AuthEffects,
      CustomersEffects,
      TourEffects,
      VehiclesEffects,
      DriversEffects,
      DepartmentsEffects,
      AbsencesEffects,
      UsersEffects,
      ConstructionSitesEffects,
      AppointmentEffects,
      RemindersEffects
    ]),
    !environment.production ? StoreDevtoolsModule.instrument({connectInZone: true}) : []
  ],
  exports: [
    HeaderComponent
  ]
})
export class CoreModule { }
